// @flow
import { has } from "../utils/helpers/objects";

import ApplicationModel from "./application/ApplicationModel";
import CaseSearchModel from "./search/CaseSearchModel";
import CaseViewModel from "./caseview/CaseViewModel";
import DetailModel from "./detail/DetailModel";
import FormModel from "./form/FormModel";
import GroupingPanelModel from "./panels/GroupingPanelModel";
import ListModel from "./list/ListModel";
import ListDetailModel from "./list/ListDetailModel";
import TabModel from "./tab/TabModel";
import TaskGroupModel from "./taskgroup/TaskGroupModel";
import UserModel from "./user/UserModel";
import UserProfileModel from "./user/UserProfileModel";
import UserServicesModel from "./user/UserServicesModel";
import ModelCatalogModel from "./modelcatalog/ModelCatalogModel";
import ConceptIndexModel from "./concepts/ConceptIndexModel";
import BusinessScenarioModel from "./concepts/BusinessScenarioModel";
import ConceptDetailModel from "./concepts/ConceptDetailModel";
import ConceptTypeDetailModel from "./concepts/ConceptTypeDetailModel";
import ContentIndexModel from "./content/ContentIndexModel";
import ContentTOCModel from "./content/ContentTOCModel";
import ContentModel from "./content/ContentModel";
import ContentTypeModel from "./content/ContentTypeModel";
import LookupOptionsModel from "./lookup/LookupOptionsModel";

import { IllegalArgumentException } from "../exceptions";

import type ModularUIResponse from "../modularui/ModularUIResponse";
import type { ModularUIModel } from "./types";

/**
 * Mapping of models and resourcetypes
 */
const RESOURCE_MODELS = [
  ApplicationModel,
  TabModel,
  ListDetailModel,
  ListModel,
  GroupingPanelModel,
  CaseSearchModel,
  CaseViewModel,
  DetailModel,
  TaskGroupModel,
  FormModel,
  UserModel,
  UserProfileModel,
  UserServicesModel,
  ModelCatalogModel,
  ConceptIndexModel,
  BusinessScenarioModel,
  ConceptDetailModel,
  ConceptTypeDetailModel,
  ContentIndexModel,
  ContentTOCModel,
  ContentModel,
  ContentTypeModel,
  LookupOptionsModel,
];

/**
 * Resolve a model by resource
 */
const resolveModel = (
  data: ModularUIResponse,
  availableModels: Array<Class<ModularUIModel>> = RESOURCE_MODELS,
): Class<ModularUIModel> | null => {
  if (!data) {
    throw new IllegalArgumentException(
      "No data or contribution available, cannot resolve model",
    );
  }

  if (!has(data.contributions, "resourcetype")) {
    throw new IllegalArgumentException(
      "Data has wrong format, missing resourcetype property in contributions, cannot resolve model",
    );
  }

  const resourceTypeModel = availableModels.find((resourceModel) =>
    resourceModel.isApplicableModel(data),
  );

  if (resourceTypeModel) {
    return resourceTypeModel;
  }

  return null;
};

export default resolveModel;
